import '@aws-amplify/ui-react/styles.css';
import Highcharts from 'highcharts';
import React from 'react';
import './App.css';


import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Provider } from "react-redux";
import Main from './site/main';
import experimentStore from './site/store/ExperimentStore';


Highcharts.setOptions({
  colors: ['#ff0000', '#0000ff', '#008000', '#edb918', '#64E572', '#FF9655', '#CB2326', '#6AF9C4'],
  global: {
    useUTC: false
  }
});

export const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: '#515193',
    },
    secondary: {
      main: '#515193',
    },
    background: {
      main: '#ffffff',
    }
  },
});


function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Provider store={experimentStore}>
          <title>Skroot Data Portal</title>
          <Main></Main>
        </Provider>
      </ThemeProvider>
    </>
  );
}

export default App;


